<template>
    <div class="flex pb-5">
        <div class="m-auto relative" @click="openModal()">
            <VeProgress v-if="getPercent() > 0 && getPercent() < 100"
                :progress="getPercent()"
                :size="125"
                empty-color="transparent"
                color="#53b546"
                :dot="`10 ${lineColor}`"
                :thickness="3"
            >
                <div class="wrapper-img"
                    :class="{'full': getPercent() == 100}">
                    <img :src="getImgUrl()" alt="" />
                    <div class="text-22 text-white"
                    :class="{'text-green-1': getPercent() != 100}"
                    >{{getPercent()}}%</div>
                </div>
            </VeProgress>
            <div v-else class="wrapper-no-progress relative">
                <div class="wrapper-img"
                    :class="{'full': getPercent() == 100}">
                    <img :src="getImgUrl()" alt="" />
                    <div class="text-center text-22 text-white"
                    :class="{'text-green-1': getPercent() != 100}"
                    >{{getPercent()}}%</div>
                </div>
            </div>
            <div class="text-center text-a-blue-0069a8 text-20">{{badge.Name}}</div>
        </div>
    </div>

</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
//component
import { VeProgress } from "vue-ellipse-progress";//https://github.com/setaman/vue-ellipse-progress/tree/v2-dev

export default {
    name: "BadgeItem",
    components: {
        VeProgress
    },
    props: {
        badge: { type: Object, required: true },
        modalController:    { type: Object },
    },
    data: function() {
        return {
            circumference: 30 * Math.PI,
            percent: 30,
            lineColor: "#53b546",
        };
    },
    created: function() {
        console.log(this.circumference);
    },
    methods: {
        openModal: function () {
            let tracking_label = this.badge.RowKey + '|' + this.badge.Name
            this.tracking.event('badge', 'click_badge', tracking_label);
            this.tracking.event('badge', 'view_badge', tracking_label);
            this.modalController.badgeAlertModal
                .setBadge(this.badge)
                .setMsg(this.badge.Description)
                .show()
        },
        getPercent: function() {
            return this.badge.Percentage * 100;
        },
        getImgUrl: function() {
            let imgUrl = ConfigManager.getApiUrl()  + "/badge/" + this.badge.PartitionKey + "/picture"
            if (!this.badge.IsObtain) {
                imgUrl += "?disable=true";
            }
            return imgUrl;
        }
    }
}
</script>
<style lang="scss">
    .ep-svg-container {
        z-index: 1;
    }
</style>
<style lang="scss" scoped>
    .wrapper-no-progress {
        width: 125px;
        height: 125px;
    }

    .wrapper-img {
        width: 115px;
        height: 115px;
        background-color: white;
        border-radius: 100%;
        overflow: hidden;
        margin: auto;

        &.full {
            background-color: #53b546;
        }

        img {
            width: 70px;
            height: 70px;
            margin: 10px auto 0 auto;
        }
    }
</style>
